import Articles from "./articles/";
import FaqContent from "./faq-content/";
import IntroContent from "./intro-content/";
import TextContent from "./text-content/";

const modul = angular
    .module("ArticleDirectives", [])
    .directive("articles", Articles)
    .directive("faqContent", FaqContent)
    .directive("introContent", IntroContent)
    .directive("textContent", TextContent);

export default modul.name;
